//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import {
  faRightToBracket,
  faArrowUpFromBracket,
  faSparkles,
  faArrowRight,
} from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'SubmissionSteps',
  components: {
    HomeBenefits: () => import('@/components/home-page/HomeBenefits.vue'),
    StepItemHorizontal: () => import('@/components/core/elements/StepItemHorizontal.vue'),
  },
  data() {
    return {
      faArrowRight,
      steps: [
        {
          icon: faRightToBracket,
          color: 'lavender',
          heading: this.$t(this.$wbr('contributor.submission.steps_sign_up_heading')),
        },
        {
          icon: faArrowUpFromBracket,
          color: 'aqua',
          heading: this.$t(this.$wbr('contributor.submission.steps_upload_{number}_product_heading'), { number: '1' }),
          link: '/artist/upload',
        },
        {
          icon: faSparkles,
          color: 'pink',
          heading: this.$t(this.$wbr('contributor.submission.steps_start_earning_heading')),
        },
      ],
    };
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
  },
  methods: {
    onStepClick(link) {
      if (!this.isLoggedIn) {
        this.$store.dispatch('modal/showSignUp');
      } else if (link) {
        window.location.href = this.$link(link).url();
      }
    },
  },
};
